window.addEventListener("DOMContentLoaded", () => {
  Product();
  mediaSwiper();
  new Swiper(".icons_row", {
    slidesPerView: "auto",
    freeMode: true,
    // mousewheel: {
    //   forceToAxis: true,
    //   sensitivity: 1,
    //   releaseOnEdges: true,
    // },
  });
});

const mediaSwiper = () => {
  let variantId = document
    .querySelector(".variant__media-selected")
    ?.innerHTML.trim();

  const index = document.querySelector(
    `.swiper__product-media .swiper-slide[data-media-id="${variantId}"]`
  );
  const options = {};
  if (index) {
    options["initialSlide"] = index.getAttribute("index") - 1;
  }

  const swiper = new Swiper(".swiper__product-media", {
    slidesPerView: "auto",
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    autoHeight: true,
    ...options,
  });

  window.productMedia = swiper;

  const nextBtn = document.querySelector(".swiper--arrow .next");
  const prevBtn = document.querySelector(".swiper--arrow .prev");
  if (nextBtn && prevBtn) {
    nextBtn.addEventListener("click", () => {
      swiper.slideNext();
    });
    prevBtn.addEventListener("click", () => {
      swiper.slidePrev();
    });
  }
};

const initialMediaHeight = () => {
  setTimeout(() => {
    const media = document.querySelector(".media-gallery");
    if (!media) return;
    const { height } = media.getBoundingClientRect();
    if (!isMobile) return;
    const detail = document.querySelector(".product__detail-wrapper");
    if (detail) detail.style.marginTop = `${Math.round(height) + 12}px`;
  }, 300);
};

const initProductPopup = () => {
  const triggerPopups = document.querySelectorAll(".has__popup");
  triggerPopups.forEach((triggerPopup) => {
    triggerPopup.querySelectorAll("a").forEach((element) => {
      element.href = "javascript:void(0)";
      element.addEventListener("click", (e) => e.preventDefault());
    });
    if (!triggerPopup) return;
    const popup = document.querySelector(".citizen-popup-content1");
    const closePopup = () => {
      popup.classList.remove("main_citizen_popup");
      window.removeEventListener("scroll", closePopup);
    };

    const handleClickOutSide = (event) => {
      if (
        popup &&
        !popup.contains(event.target) &&
        triggerPopup &&
        !triggerPopup.contains(event.target)
      ) {
        popup.classList.remove("main_citizen_popup");
        document.removeEventListener("click", handleClickOutSide);
      }
    };

    triggerPopup.addEventListener("click", (event) => {
      if (popup.classList.contains("main_citizen_popup")) {
        closePopup();
        return;
      }
      popup.classList.add("main_citizen_popup");

      const yMouse = event.clientY;
      popup.style.top = `${yMouse}px`;
      window.addEventListener("scroll", closePopup);
      document.addEventListener("click", handleClickOutSide);
    });
  });
};

const mutationReviews = () => {
  // Chọn phần tử cần theo dõi
  const targetDiv = document.querySelector(".jdgm-review-widget");
  let updated = false;
  if (targetDiv) {
    // Tạo một observer
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          const reviews = targetDiv.querySelectorAll(".jdgm-rev");
          if (reviews.length > 0) {
            reviews.forEach((item) => {
              const existDiv = item.querySelector(".updated-timestamp");
              const rowExtra = item.querySelector(".jdgm-row-extra");
              if (existDiv || !rowExtra) return;
              const time = item.querySelector(".jdgm-rev__timestamp");
              const newDiv = document.createElement("div");
              newDiv.className = "updated-timestamp";
              newDiv.innerHTML = time.innerHTML;
              rowExtra.appendChild(newDiv);
            });
          }
        }
      });
    });

    const config = {
      childList: true,
      attributes: true,
      subtree: true,
    };

    // Bắt đầu theo dõi
    observer.observe(targetDiv, config);
  } else {
    console.log("Không tìm thấy div jdgm-glider-track.");
  }
};

const customBtn = () => {
  const customBtn = document.querySelector(".custom__btn_submit-mb button");
  if (customBtn) {
    customBtn.addEventListener("click", () => {
      const btnSubmit = document.querySelector(".add-to-cart");
      const checkedSize = document.querySelector(".option--Size input:checked");
      const checkedColor = document.querySelector(
        ".option--Color input:checked"
      );
      const checkInputSize = document.querySelector(".option--Size input");
      const checkInputColor = document.querySelector(".option--Color input");

      if (!checkInputColor || !checkInputSize) {
        customBtn.classList.add("is-loading");
        customBtn.disabled = true;
        btnSubmit.click();

        return;
      }

      if (!checkedSize || !checkedColor) {
        document
          .querySelector(".option-selector[data-option='Color'")
          ?.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        !checkedColor && window.showToast("Please select a color", 3000);
        !checkedSize && window.showToast("Please select a size", 3000);
        return;
      }
      customBtn.classList.add("is-loading");
      customBtn.disabled = true;
      btnSubmit.click();
    });
  }
};

const goToReviewWidget = () => {
  document.querySelectorAll(".title__star").forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const { top } = document
        .querySelector("#judgeme_product_reviews")
        .getBoundingClientRect();
      let _top = top;
      if (!isMobile) {
        _top = top - 70;
        window.scrollTo({ top: _top, behavior: "smooth" });
      } else {
        document.querySelector("#judgeme_product_reviews").scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  });
};

const scrollingTextMobile = () => {
  const texts = document.querySelectorAll(
    ".scrolling__text-mobile .scrolling__text-item"
  );
  let currentIndex = 0;

  function fadeText() {
    if (!texts[currentIndex]) return;
    texts[currentIndex].classList.remove("show");

    setTimeout(() => {
      currentIndex = (currentIndex + 1) % texts.length;
      texts[currentIndex].classList.add("show");
    }, 300);
  }

  setInterval(fadeText, 5000);
};

const scrollingTextDesktop = () => {
  const texts = document.querySelectorAll(
    ".scrolling__text-desktop .scrolling__text-item"
  );
  let currentIndex = 0;

  function fadeText() {
    if (!texts[currentIndex]) return;
    texts[currentIndex].classList.remove("show");

    setTimeout(() => {
      currentIndex = (currentIndex + 1) % texts.length;
      texts[currentIndex].classList.add("show");
    }, 300);
  }

  setInterval(fadeText, 5000);
};

const Product = () => {
  initProductPopup();
  mutationReviews();
  customBtn();
  goToReviewWidget();
  scrollingTextMobile();
  scrollingTextDesktop();
};
